
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.44 37.38a45.9 45.9 0 016.13 1.25M27 37c1-.06 2-.09 3-.09s2.14 0 3.2.11M17.26 38.68a47.62 47.62 0 016.24-1.3M12.75 49.76h34.5V58h-34.5zM47.25 27.68a50.78 50.78 0 00-34.5 0V21a50.78 50.78 0 0134.5 0zM22.92 49.23V24.96M26.92 24.96v24.27M33.08 49.23V24.96M37.08 24.96v24.27M12.75 49.23v-21.4M16.75 26.68v22.55M43.25 49.23V26.68M47.25 27.83v21.4M29.97 18.7V5M29.97 5h6.08v4.05h-6.08z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M46.72 49.38l6.98 3.35V58M13.28 49.38L6.3 52.73V58M47.66 21.15h11.58v6.43H47.66"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M59.24 27.58V58H46.25M12.34 21.15H.76v6.43h11.58M.76 27.58V58h12.99"}})])
          )
        }
      }
    